module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN328_1123441646.8ad49598.png";